import { ref } from '@vue/composition-api'
import store from '@/store'
import { DOWNLOAD_TYPES, FILE_FORMATS } from '@/constants'
import { DOWNLOAD_DELIVERABLE } from '@/common-utils'
import { DOWNLOAD_COLLECTION } from '@/store/modules/collection.module'
import { SHOW_DOWNLOADS_NAV_INDICATOR } from '@/store/modules/notification.module'
import { apiToastSuccess } from '@/@core/utils/toast'

// Values may be plain or reactive getters, since the callers pass props.
const read = value => (typeof value === 'function' ? value() : value)

/**
 * Dispatching a collection download — the one place it happens.
 *
 * Both the v2 modal and the legacy modal host the same shared picker and had
 * their own near-identical copy of this: build the payload, dispatch, toast,
 * poke the downloads nav, close only on "download everything". They had also
 * started to drift, so it lives here now.
 *
 * `onWholeCollection` is the only genuine difference between the hosts — one
 * emits, the other hides a bootstrap modal by id.
 */
export function useCollectionDownload({
  collectionId,
  retailerId = null,
  onWholeCollection = null,
}) {
  const downloading = ref(false)

  const buildPayload = choice => {
    const retailer = read(retailerId)
    return {
      downloadType: DOWNLOAD_TYPES.COLLECTION_EXPORT.VALUE,
      respectiveId: read(collectionId),
      fileType: FILE_FORMATS.XLSX,
      ...(retailer ? { retailerId: retailer } : {}),
      ...choice,
    }
  }

  const downloadCatalogue = choice => {
    downloading.value = true
    return store
      .dispatch(DOWNLOAD_COLLECTION, { payload: buildPayload(choice) })
      .then(res => {
        apiToastSuccess(res.data.message)
        store.commit(SHOW_DOWNLOADS_NAV_INDICATOR)
        // Only "download everything" ends the session — single and selected
        // downloads keep the popup open for more picks.
        if (choice.deliverable === DOWNLOAD_DELIVERABLE.ALL && onWholeCollection) {
          onWholeCollection()
        }
      })
      .catch(() => {})
      .then(() => {
        downloading.value = false
      })
  }

  return { downloading, downloadCatalogue }
}
